export default {"src":"/_next/static/image/src/assets/gifs/loader-grey.3faceea42553a945ee39cc9309b7fb88.gif","height":100,"width":100};